/**
 * Created by sumudu on 5/4/16.
 */
angular.module('aeroLineCrew').config([
    'localStorageServiceProvider',
    '$httpProvider',
    'toastrConfig',
    'uiMask.ConfigProvider',
    '$compileProvider',
    'KeepaliveProvider',
    'IdleProvider',
    function (localStorageServiceProvider, $httpProvider,toastrConfig,uiMaskConfigProvider, $compileProvider, KeepaliveProvider, IdleProvider) {

        //localStorageProvider config
        localStorageServiceProvider
            .setPrefix('ALC')
        //.setStorageType('sessionStorage') //sessionStorage

        //Set HTTP Interceptor
        $httpProvider.interceptors.push('aeroLineHttpInterceptor');

        /*//Configure Slide in Panels
        panelsProvider.add(
            {
                id : 'crewing.right.panel',
                position: 'right',
                size: '320px',
                templateUrl: 'crewing/views/crewing-right-panel.tpl.html',
                controller: 'CrewingRightPanelCtrl'
            }
        );*/

        angular.extend(toastrConfig, {
            autoDismiss: false,
            tapToDismiss: true,
            closeButton: true,
            containerId: 'toast-container',
            maxOpened: 0,
            timeOut: 5000,
            extendedTimeOut :2000,
            newestOnTop: true,
            positionClass: 'toast-bottom-right',
            preventDuplicates: false,
            preventOpenDuplicates: true,
            templates: {
                toast: 'toastr-custome.tpl.html'
            },
            target: 'body'
        });

        uiMaskConfigProvider.maskDefinitions({
            '1': /[0-1]/,
            '2': /[0-2]/,
            '3': /[0-3]/,
            '4': /[0-4]/,
            '6': /[0-5]/

        });
        uiMaskConfigProvider.clearOnBlur(false);
        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|file|blob):/);

      IdleProvider.interrupt('keydown wheel mousedown touchstart touchmove scroll');

    }]);
